module.exports = __webpack_public_path__ + "static/media/chart-pie.6bbf7bed.svg";